
export default {
  professions: []
}
